export default "__VITE_ASSET__CvLobTV___"